import { Component, Mixins, Prop } from 'vue-property-decorator';
import addStaffPicksSuggestionMutation from '../../mutations/addStaffPicksSuggestion';
import staffPicksSuggestionsQuery from '../../queries/staffPicksSuggestions';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListStaffPicksAdder extends Mixins(UtilMixin) {
  @Prop() public suggestionsList!: any;

  public readonly query = staffPicksSuggestionsQuery;

  public readonly mutation = addStaffPicksSuggestionMutation;

  public mutationVariables(suggestionCandidate: any) {
    return {
      suggestionsListId: this.suggestionsList.id,
      publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
      staffPicks: suggestionCandidate.source.staffPicks,
    };
  }
}
